import apiClient from './axios';
import type { ApiEnvelope, LoginResponse, VendorUser } from '../types';

export const authApi = {
  async login(email: string, password: string): Promise<LoginResponse> {
    const res = await apiClient.post<ApiEnvelope<LoginResponse>>(
      '/vendor/auth/login',
      { email, password },
    );
    return res.data.data;
  },

  async me(): Promise<VendorUser> {
    const res = await apiClient.get<ApiEnvelope<VendorUser>>(
      '/vendor/auth/me',
    );
    return res.data.data;
  },

  async logout(refreshToken: string): Promise<void> {
    await apiClient.post('/vendor/auth/logout', { refreshToken });
  },

  async changePassword(
    currentPassword: string,
    newPassword: string,
  ): Promise<{ message: string }> {
    const res = await apiClient.post<ApiEnvelope<{ message: string }>>(
      '/vendor/auth/change-password',
      { currentPassword, newPassword },
    );
    return res.data.data;
  },
};
